(function ($) {
    $(document).ready(function () {
        carouselThreeCenteredSlider();
    });

    function carouselThreeCenteredSlider() {
        const wraps = document.querySelectorAll('.section_post_preview.posts_carousel_three_centered .children_section');
        if (wraps.length > 0) {
            wraps.forEach((element) => {
                const slider = element.querySelector('.children_previews .swiper.carousel_three_centered');
                let slides = element.querySelectorAll('.children_previews .swiper.carousel_three_centered .item_wrap');
                if (slider.length !== 0) {
                    let carouselThreeCenteredSwiper = new Swiper('.swiper.carousel_three_centered', {
                        slidesPerView: 3,
                        loop: true,
                        spaceBetween: 0,
                        speed: 600,
                        navigation: {
                            nextEl: element.querySelector('.children_section .pager_wrap .arrow.next'),
                            prevEl: element.querySelector('.children_section .pager_wrap .arrow.prev'),
                        },
                        breakpoints: {
                            992: {
                                slidesPerView: 5,
                                spaceBetween: 10,
                            }
                        }

                    });
                    if (slides.length <= 7) {
                        const containerSlides = slider.querySelector('.inner_wrapper');
                        const slidesToClone = containerSlides.querySelectorAll('.item_wrap');
                        slidesToClone.forEach((element) => {
                            let clone = element.cloneNode(true);
                            containerSlides.append(clone);
                        });
                    }
                }
            });
        }
    }

}(jQuery));
